import React from 'react';
import { MdArrowDropDown } from 'react-icons/md';
import { Waypoint } from 'react-waypoint';
import { DropdownMenu, ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { FavouriteSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import {
  defaultFilters, favouriteFilters, favouriteQueryFilters, predefinedFilters
} from 'app/area/favourite-administration/list/favourites-filter-configuration';
import styles from './list-renderer.scss';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, loadList, deleteFavourite, changeOwner, changeUserGroups, changeUsers, translation
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults, deletingFavourite } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: FavouriteSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const topToolbar = <div className="row">
    <h1 className="col-12">{translation.manage_favourites}</h1>
  </div>;

  const toggle = <div>
    <span>{translation.mass_update_of}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  const rightToolbar =
    <DropdownMenu dropdownNode={toggle} closeAfterClick>
      <button className="dropdown-item"
        id={'change-owner'}
        onClick={changeOwner}
        disabled={!numberOfResults}>
        {translation.owner}
      </button>
      <button className="dropdown-item"
        id={'change-user-groups'}
        onClick={changeUserGroups}
        disabled={!numberOfResults}>
        {translation.change_user_groups}
      </button>
      <button className="dropdown-item"
        id={'change-users'}
        onClick={changeUsers}
        disabled={!numberOfResults}>
        {translation.shared_with_users}
      </button>
    </DropdownMenu>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      hideAttributesLabel={true}
      filtersConfig={{ area: 'favouriteAdministration' }}
      queryFilters={favouriteQueryFilters(translation)}
      predefinedFilters={predefinedFilters(translation)}
      customFilters={favouriteFilters(translation)}
      defaultFilterValues={defaultFilters()}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="company_reports_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_favourite
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          deletingFavourite={deletingFavourite}
          deleteFavourite={deleteFavourite}
          translation={translation} />
        : null}
      <Waypoint key="wpFavouriteAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
